// initial state
const state = {
  options: {
    type: [
      {label: '首次合作', value: 1},
      {label: '常规客户', value: 2},
      {label: '潜在客户', value: 3},
      {label: '客户采购', value: 4},
    ],
    status: [
      {label: '无效', value: 0},
      {label: '有效', value: 1},
    ],
    pushStatus: [
      {label: '投递失败', value: 0},
      {label: '投递成功', value: 1},
    ]
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const satisfactionEmail = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/satisfaction-email/satisfaction-email.store.js